<div class="customers">
    <div>
        <div class="card-body">
            <div class="row">
                <div class="separator" [ngClass]="'color-back-area-' + areaNumber" style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                    <div class="estrategia-text"><strong>{{subdimensionData?.subdimension}}</strong></div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="content" style="text-align: center;">OBJETIVOS ESTRATÉGICOS</p>
                </div>
                <div class="col">
                    <p class="content" style="text-align: center;">METAS ANUALES</p>
                </div>
                <div class="col">
                    <p class="content" style="text-align: center;">ESTRATEGIAS</p>
                    <p class="content" style="text-align: center;">(Máximo 2 por Meta Anual)</p>
                </div>
            </div>

            <div class="row">
                <div *ngFor="let objetivoArea of subdimensionData.objetivosAreas; let indice=index;">
                    <app-objetivos-estrategicos-fe [indice]="indice" [estadoData]="estadoData" [objetivoArea]="objetivoArea" [areaNumber]="areaNumber" [simulacion]="simulacion"></app-objetivos-estrategicos-fe>
                </div>
            </div>
        </div>
    </div>
</div>